// extracted by mini-css-extract-plugin
export var copyright = "StoreLayout-module--copyright--S7iPw";
export var footer = "StoreLayout-module--footer--zuNop";
export var grid = "StoreLayout-module--grid--jM2oW";
export var main = "StoreLayout-module--main--3BfkC";